import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompetitiveRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { MICRO_FRONTENDS, STYLES } from '@core/constants';
import { environment } from '@environments/environment';
import { WebAdapterService } from '@core/web-adapter/web-adapter.service';


@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    CompetitiveRoutingModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class HomeModule {}
